import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDesktop,
  faSignOutAlt,
  faEnvelope,
  faPlus,
  faBell,
  faDna,
  faSeedling,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";
import { faBell as faBellRegular } from "@fortawesome/free-regular-svg-icons";
import { useMsal } from "../../msal-context";
import RenderRoute from "../../RenderRoute";
import { CloseButton, Dropdown } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import Notify from "../Notifications/notifyOverlay";
import Announcements from "../Announcements/announcements";
import Search from "../Search/search";
import Wiki from "../Wiki/wiki"
import logo from '../../../src/assets/logonew.svg';
import sidebarbutton from '../../assets/sidebarbutton.svg'
import { ReactComponent as SampleIcon } from '../../assets/sampleIcon.svg'
import { ReactComponent as ResultIcon } from '../../assets/resultIcon.svg'
import { ReactComponent as ManageIcon } from '../../assets/manageIcon.svg'
import { ReactComponent as DashboardSidebarIcon } from '../../assets/dashboardSidebarIcon.svg'
import { ReactComponent as AddIconUser } from '../../assets/addUserThree.svg';
import wikiNewIcon from '../../assets/wikiNewIcon.svg'
import { Row, Col, Button } from "reactstrap";
import "./appHeader.css";
import { Navigation } from "react-minimal-side-navigation";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import { useHistory } from "react-router-dom";
import Tour from '../../Tour'
import Report from '../Report/report'
import AddSample from '../AddSample/addSample'
import AddSpeciesSample from '../../species/AddSample/addSample'
import { appInsights } from "../../AppInsights";
import { Image } from "react-bootstrap";
import LanguageSelector from '../LanguageSelector/languageSelector';
import { useTranslation } from 'react-i18next';

//For the side navigation bar
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarContent, SidebarFooter, SidebarHeader } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { Link, useLocation } from 'react-router-dom';


export const AppHeader = (props) => {
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { loading, logout } = useMsal();
  const [sampleSearch, setSearchValue] = useState("");
  const [isTourOpen, setTourOpen] = useState(false);
  const [isReportModalOpen, setisReportModalOpen] = useState(false);
  const [addSampleOpen, setaddSampleOpen] = useState(false);
  const [announceSessionStatus, handleChange] = useState(false);
  const [announceStatus, handleAnnouncements] = useState("");
  const [searchFilterword, setSearchFilterword] = useState("");
  const [ifNewNotif, checkNewNotif] = useState(false)
  const [dropdownOpen, selectedDropdown] = useState('NA')
  const [sideBarHover, setSideBarHover] = useState(false)
  const [activeIndex, setActiveIndex] = useState(() => {
    const initialIndex =
      window.location.pathname.includes('/samples') && !window.location.pathname.includes('addsamples') ? 0
        : window.location.pathname.includes('/addsamples') ? 1
          : window.location.pathname.includes('/results/viewresults') || window.location.pathname == '/results/' || window.location.pathname == '/results' ? 2
            : window.location.pathname.includes('/results/trackresults') ? 3
              : window.location.pathname.includes('/results/snpresults') ? 4
                : window.location.pathname.includes('/results/biomeresults') ? 5
                  : window.location.pathname.includes('/results/speciesdensity') ? 6
                    : window.location.pathname.includes('/manage/buildings/addbuildings') || window.location.pathname == '/manage/' ? 7
                      : window.location.pathname.includes('/manage/locations') ? 8
                        : window.location.pathname.includes('/manage/notifications') ? 9
                          : window.location.pathname.includes('/dashboard') ? 10
                            : window.location.pathname.includes('/register') ? 11
                              : window.location.pathname.includes('/unathorised') ? 12
                                : null
    return initialIndex;
  });

  const location = useLocation();
  useEffect(() => {
    if (window.location.pathname.includes('/samples') && !window.location.pathname.includes('addsamples')) {
      setActiveIndex(0)
    }
    else if (window.location.pathname.includes('/addsamples')) {
      setActiveIndex(1)
    }
    else if (window.location.pathname.includes('/results/viewresults') || window.location.pathname == '/results/' || window.location.pathname == '/results') {
      setActiveIndex(2)
    }
    else if (window.location.pathname.includes('/results/trackresults')) {
      setActiveIndex(3)
    }
    else if (window.location.pathname.includes('/results/snpresults')) {
      setActiveIndex(4)
    }
    else if (window.location.pathname.includes('/results/biomeresults')) {
      setActiveIndex(5)
    }
    else if (window.location.pathname.includes('/results/speciesdensity')) {
      setActiveIndex(6)
    }
    else if (window.location.pathname.includes('/manage/buildings/addbuildings') || window.location.pathname == '/manage/') {
      setActiveIndex(7)
    }
    else if (window.location.pathname.includes('/manage/locations')) {
      setActiveIndex(8)
    }
    else if (window.location.pathname.includes('/manage/notifications')) {
      setActiveIndex(9)
    }
    else if (window.location.pathname.includes('/dashboard')) {
      setActiveIndex(10)
    }
    else if (window.location.pathname.includes('/register')) {
      setActiveIndex(11)
    }
    else if (window.location.pathname.includes('/unauthorised')) {
      setActiveIndex(12)
    }
  });

  let history = useHistory();

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);
  const closeTour = () => {
    setTourOpen(false);
  };
  const openTour = () => {
    setTourOpen(true);
  };
  const setSearch = (data) => {
    setSearchValue(data);
  };
  const report = () => {
    setisReportModalOpen(!isReportModalOpen);
  };

  const toggleAddSampleModal = () => {
    setaddSampleOpen(!addSampleOpen);
  };

  const handleAllChange = () => {
    handleChange(false);
    sessionStorage.setItem('announce_session_status', JSON.stringify(announceSessionStatus))
    sessionStorage.setItem('announcements_session', JSON.stringify(announceStatus));
  };

  const loggingOut = () => {
    if (localStorage.getItem("guest")) {
      localStorage.removeItem("guest");
      if (localStorage.getItem("species"))
        localStorage.removeItem("species");
      sessionStorage.clear();
      history.push("/");
    }
    else logout();
  };
  let user;

  if (localStorage.getItem("auth_token")) {
    user = jwt_decode(localStorage.getItem("auth_token"))
    if (user && user.name && appInsights) {
      let validatedId = user.name.replace(/[,;=| ]+/g, "_");
      appInsights.setAuthenticatedUserContext(validatedId)
    }
  }

  if (localStorage.getItem("userInfo")) {
    user = jwt_decode(localStorage.getItem("userInfo"));
  }
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {window.location.pathname.includes('/extlogin') ?
        <></> :
        <>
          <>
            {windowWidth > 900 &&
              <div className="sidebar" data-tut="reactour__navbar" onMouseLeave={() => { props.setSideBarOpen(false); setSideBarHover(false) }} onMouseEnter={() => setSideBarHover(true)} >
                <ProSidebar width={250} collapsed={!props.isSidebarOpen}>
                  <SidebarHeader>
                  </SidebarHeader>
                  <SidebarContent>
                    <Menu iconShape="square">
                      <MenuItem className={[10].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(10); selectedDropdown('dashboard') }} icon={<DashboardSidebarIcon className={[10].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>{t('sidebar.dashboard')} <Link to="/dashboard" /></MenuItem>

                      <SubMenu className={[0, 1].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} open={dropdownOpen == 'samples' ? true : false} title={t('sidebar.samples')} icon={<SampleIcon className={[0, 1].indexOf(activeIndex) >= 0 ? 'active-menu sample-size' : "ham-item sample-size"} />} onOpenChange={() => { history.push("/samples/"); selectedDropdown('samples') }}>
                        <MenuItem active={activeIndex === 0}>{t('sidebar.floorView')} <Link to="/samples/floormap/" onClick={() => setActiveIndex(0)} /></MenuItem>
                        <MenuItem active={activeIndex === 1}>{t('sidebar.listOfSamples')} <Link to="/samples/addsamples/" onClick={() => setActiveIndex(1)} /></MenuItem>
                      </SubMenu>

                      <SubMenu className={[2, 3, 4, 5, 6].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} open={dropdownOpen == 'results' ? true : false} title={t('sidebar.results')} onOpenChange={() => { history.push("/results/"); selectedDropdown('results') }} icon={<ResultIcon onClick={() => { history.push("/results/") }} className={[2, 3, 4, 5, 6].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>
                        <MenuItem active={activeIndex === 2}>{t('sidebar.allResults')} <Link to="/results/" onClick={() => setActiveIndex(2)} /></MenuItem>
                        <MenuItem active={activeIndex === 3}>{localStorage.getItem('species') ? t('sidebar.trackSpecies') : t('sidebar.trackResults')} <Link to="/results/trackresults/" onClick={() => setActiveIndex(3)} /></MenuItem>
                        {localStorage.getItem('species') ? null
                          :
                          <>
                            <MenuItem active={activeIndex === 4}>{t('sidebar.snpResults')} <Link to="/results/snpresults/" onClick={() => setActiveIndex(4)} /></MenuItem>
                            <MenuItem active={activeIndex === 5}>{t('sidebar.microbiomeResults')} <Link to="/results/biomeresults/" onClick={() => setActiveIndex(5)} /></MenuItem>
                          </>
                        }
                        <MenuItem active={activeIndex === 6}>{t('sidebar.speciesDensity')} <Link to={localStorage.getItem('species') ? '/results/speciesresults/' : "/results/speciesdensity/"} onClick={() => setActiveIndex(6)} /></MenuItem>
                      </SubMenu>

                      <SubMenu className={[7, 8, 9].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} open={dropdownOpen == 'manage' ? true : false} title={t('sidebar.manage')} onOpenChange={() => { history.push("/manage/"); selectedDropdown('manage') }} icon={<ManageIcon onClick={() => { history.push("/manage/") }} className={[7, 8, 9].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>
                        <MenuItem active={activeIndex === 7}>{t('sidebar.manageLocations')} <Link to="/manage/" onClick={() => setActiveIndex(7)} /></MenuItem>
                        <MenuItem active={activeIndex === 8}>{t('sidebar.viewLocations')} <Link to="/manage/locations" onClick={() => setActiveIndex(8)} /></MenuItem>
                        <MenuItem active={activeIndex === 9}>{t('sidebar.manageNotifications')} <Link to="/manage/notifications/" onClick={() => setActiveIndex(9)} /></MenuItem>
                      </SubMenu>

                      {/* auth_token.user_group checks for role from custom login and auth_token.roles checks if user is a supervisor or not */}
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && ((jwt_decode(localStorage.getItem('auth_token')).user_group && jwt_decode(localStorage.getItem('auth_token')).user_group.includes('admin')) || !('token_type' in jwt_decode(localStorage.getItem('auth_token')))) ?
                        <MenuItem className={[11].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(11); selectedDropdown('register') }} icon={<AddIconUser className={[11].indexOf(activeIndex) >= 0 ? 'active-menu increase-register-size' : "ham-item register-size"} />}>{t('navbar.userManagement')} <Link to="/register" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title={t('sidebar.externalUsers')} className={[13].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(13); selectedDropdown('external-users') }} icon={<AddIconUser className={[13].indexOf(activeIndex) >= 0 ? 'active-menu increase-register-size' : "ham-item register-size"} />}>{t('sidebar.externalUsers')} <Link to="/external-users" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Análise Sanger" className={[14].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(14); selectedDropdown('sanger') }} icon={<FontAwesomeIcon icon={faDna} className={[14].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Análise Sanger <Link to="/sanger" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Análise Agro" className={[15].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(15); selectedDropdown('agro') }} icon={<FontAwesomeIcon icon={faSeedling} className={[15].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Análise Agro <Link to="/agro" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Auditoria de Lojas" className={[16].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(16); selectedDropdown('auditoria') }} icon={<FontAwesomeIcon icon={faClipboardCheck} className={[16].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Auditoria de Lojas <Link to="/auditoria" /></MenuItem>
                        : null
                      }
                    </Menu>
                  </SidebarContent>
                  {props.isSidebarOpen ?
                    <SidebarFooter className={!props.isSidebarOpen ? "footer-sidebar-collapsed" : "footer-sidebar"}>
                      © Eurofins Genomics 2020
                    </SidebarFooter>
                    : null}
                </ProSidebar>;
              </div>
            }

            {windowWidth <= 900 && windowWidth >= 768 && props.isSidebarOpen &&
              <div className="sidebar" data-tut="reactour__navbar" onMouseLeave={() => props.setSideBarOpen(false)}>
                <ProSidebar width={250} collapsed={false}>
                  <SidebarHeader></SidebarHeader>
                  <SidebarContent>
                    <Menu iconShape="square">
                      <MenuItem className={[10].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(10); selectedDropdown('dashboard') }} icon={<DashboardSidebarIcon className={[10].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Dashboard <Link to="/dashboard" /></MenuItem>
                      <SubMenu className={[0, 1].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} open={dropdownOpen == 'samples' ? true : false} title="Samples" icon={<SampleIcon className={[0, 1].indexOf(activeIndex) >= 0 ? 'active-menu sample-size' : "ham-item sample-size"} />} onOpenChange={() => { history.push("/samples/"); selectedDropdown('samples') }}>
                        <MenuItem active={activeIndex === 0}>Floor View <Link to="/samples/floormap/" onClick={() => setActiveIndex(0)} /></MenuItem>
                        <MenuItem active={activeIndex === 1}>List of Samples <Link to="/samples/addsamples/" onClick={() => setActiveIndex(1)} /></MenuItem>
                      </SubMenu>

                      <SubMenu className={[2, 3, 4, 5, 6].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} open={dropdownOpen == 'results' ? true : false} title="Results" onOpenChange={() => { history.push("/results/"); selectedDropdown('results') }} icon={<ResultIcon onClick={() => { history.push("/results/") }} className={[2, 3, 4, 5, 6].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>
                        <MenuItem active={activeIndex === 2}>All Results <Link to="/results/" onClick={() => setActiveIndex(2)} /></MenuItem>
                        <MenuItem active={activeIndex === 3}>{localStorage.getItem('species') ? 'Track Species' : 'Track Results'}<Link to="/results/trackresults/" onClick={() => setActiveIndex(3)} /></MenuItem>
                        {localStorage.getItem('species') ? null
                          :
                          <>
                            <MenuItem active={activeIndex === 4}>SNP Results <Link to="/results/snpresults/" onClick={() => setActiveIndex(4)} /></MenuItem>
                            <MenuItem active={activeIndex === 5}>Microbiome Results <Link to="/results/biomeresults/" onClick={() => setActiveIndex(5)} /></MenuItem>
                          </>}
                        <MenuItem active={activeIndex === 6}>Species Density <Link to={localStorage.getItem('species') ? '/results/speciesresults/' : "/results/speciesdensity/"} onClick={() => setActiveIndex(6)} /></MenuItem>
                      </SubMenu>

                      <SubMenu className={[7, 8, 9].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} open={dropdownOpen == 'manage' ? true : false} title="Manage" onOpenChange={() => { history.push("/manage/"); selectedDropdown('manage') }} icon={<ManageIcon onClick={() => { history.push("/manage/") }} className={[7, 8, 9].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>
                        <MenuItem active={activeIndex === 7}>Manage Locations <Link to="/manage/" onClick={() => setActiveIndex(7)} /></MenuItem>
                        <MenuItem active={activeIndex === 8}>View Locations <Link to="/manage/locations" onClick={() => setActiveIndex(8)} /></MenuItem>
                        <MenuItem active={activeIndex === 9}>Manage Notifications <Link to="/manage/notifications/" onClick={() => setActiveIndex(9)} /></MenuItem>
                      </SubMenu>


                      {/* auth_token.user_group checks for role from custom login and auth_token.roles checks if user is a supervisor or not */}
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && ((jwt_decode(localStorage.getItem('auth_token')).user_group && jwt_decode(localStorage.getItem('auth_token')).user_group.includes('admin')) || !('token_type' in jwt_decode(localStorage.getItem('auth_token')))) ?
                        <MenuItem className={[11].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(11); selectedDropdown('register') }} icon={<AddIconUser className={[11].indexOf(activeIndex) >= 0 ? 'active-menu increase-register-size' : "ham-item register-size"} />}>{t('navbar.userManagement')} <Link to="/register" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title={t('sidebar.externalUsers')} className={[13].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(13); selectedDropdown('external-users') }} icon={<AddIconUser className={[13].indexOf(activeIndex) >= 0 ? 'active-menu increase-register-size' : "ham-item register-size"} />}>{t('sidebar.externalUsers')} <Link to="/external-users" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Análise Sanger" className={[14].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(14); selectedDropdown('sanger') }} icon={<FontAwesomeIcon icon={faDna} className={[14].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Análise Sanger <Link to="/sanger" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Análise Agro" className={[15].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(15); selectedDropdown('agro') }} icon={<FontAwesomeIcon icon={faSeedling} className={[15].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Análise Agro <Link to="/agro" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Auditoria de Lojas" className={[16].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(16); selectedDropdown('auditoria') }} icon={<FontAwesomeIcon icon={faClipboardCheck} className={[16].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Auditoria de Lojas <Link to="/auditoria" /></MenuItem>
                        : null
                      }
                    </Menu>
                  </SidebarContent>
                  {props.isSidebarOpen ?
                    <SidebarFooter className={!props.isSidebarOpen ? "footer-sidebar-collapsed" : "footer-sidebar"}>
                      © Eurofins Genomics 2020
                    </SidebarFooter>
                    : null}
                </ProSidebar>;
              </div>
            }

            {windowWidth < 768 && props.isSidebarOpen &&
              <div className="sidebar" data-tut="reactour__navbar" onMouseLeave={() => props.setSideBarOpen(false)}>
                <ProSidebar width={250} collapsed={false}>
                  <SidebarHeader></SidebarHeader>
                  <SidebarContent>
                    <Menu iconShape="square">
                      <MenuItem className={[10].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(10); selectedDropdown('dashboard') }} icon={<DashboardSidebarIcon className={[10].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Dashboard <Link to="/dashboard" /></MenuItem>
                      <MenuItem className={[0, 1].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(0); selectedDropdown('samples') }} icon={<SampleIcon className={[0, 1].indexOf(activeIndex) >= 0 ? 'active-menu sample-size' : "ham-item sample-size"} />}>Add a sample <Link to="/samples" /></MenuItem>
                    {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title={t('sidebar.externalUsers')} className={[13].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(13); selectedDropdown('external-users') }} icon={<AddIconUser className={[13].indexOf(activeIndex) >= 0 ? 'active-menu increase-register-size' : "ham-item register-size"} />}>{t('sidebar.externalUsers')} <Link to="/external-users" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Análise Sanger" className={[14].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(14); selectedDropdown('sanger') }} icon={<FontAwesomeIcon icon={faDna} className={[14].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Análise Sanger <Link to="/sanger" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Análise Agro" className={[15].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(15); selectedDropdown('agro') }} icon={<FontAwesomeIcon icon={faSeedling} className={[15].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Análise Agro <Link to="/agro" /></MenuItem>
                        : null
                      }
                      {localStorage.getItem('auth_token') && jwt_decode(localStorage.getItem('auth_token')) && !jwt_decode(localStorage.getItem('auth_token')).is_external ?
                        <MenuItem title="Auditoria de Lojas" className={[16].indexOf(activeIndex) >= 0 ? 'active-menu-title' : ""} onClick={() => { setActiveIndex(16); selectedDropdown('auditoria') }} icon={<FontAwesomeIcon icon={faClipboardCheck} className={[16].indexOf(activeIndex) >= 0 ? 'active-menu' : "ham-item"} />}>Auditoria de Lojas <Link to="/auditoria" /></MenuItem>
                        : null
                      }
                    </Menu>
                  </SidebarContent>
                  {props.isSidebarOpen ?
                    <SidebarFooter className={!props.isSidebarOpen ? "footer-sidebar-collapsed" : "footer-sidebar"}>
                      © Eurofins Genomics 2020
                    </SidebarFooter>
                    : null}
                </ProSidebar>;
              </div>
            }
          </>
          <>
            {props.isWikiSidebar && window.innerWidth > 767 ? (
              <div className="side-bar-right">
                <div>
                  <CloseButton className="graph-button-2" aria-label="Hide" onClick={() => { props.setWikiSidebar(false); setSearchFilterword(""); }} />
                </div>
                <Wiki searchFilterword={searchFilterword} />
              </div>
            ) : null}
          </>
          <header className="app-header" >
            <Row form className="navbar-custom body-margin">
              <Col md={0.5} data-tut="reactour__ham">
                <img src={sidebarbutton} onClick={() => props.setSideBarOpen(!props.isSidebarOpen)} className="hamburge-button" alt="" />
              </Col>
              <div className='serach-vertical-line-logo' />
              <Col md={1} className="logo-max-width">
                <img
                  className="header-img"
                  src={logo}
                  onClick={() => window.location.href = "/dashboard"}
                  data-tut="reactour__dashboard"
                  alt=""
                />
              </Col>
              {windowWidth > 600 && (
                <Search sampleSearch={sampleSearch} setSearch={setSearch} />
              )}
              <Col className={localStorage.getItem('species') || localStorage.getItem('guest') ? "header-items samples-header-right" : "header-items samples-header-right header-items-actual"}>
                <div className="add-sample d-none d-lg-block" data-tut="reactour__addsample" onClick={toggleAddSampleModal}> <FontAwesomeIcon icon={faPlus} className="fa-1x demo-icon" style={{ color: "#FFFFFF" }} />  {t('common.addSample')}
                </div>
                {window.innerWidth > 767 ?
                  <Dropdown className="wiki" data-tut="reactour__article" onClick={() => { props.setWikiSidebar(!props.isWikiSidebar); setSearchFilterword(""); }}>
                    <abbr title="Wiki Space">
                      <Dropdown.Toggle variant="" id="" className="wiki-search-icon">
                        <img src={wikiNewIcon} className='wiki-icon' />
                      </Dropdown.Toggle>
                    </abbr>
                  </Dropdown>
                  : null
                }
                {windowWidth > 900 ?
                  <Dropdown className="help report-icon" data-tut="reactour__help">
                    <Dropdown.Toggle variant="" id="" className="help-toggle help-icon-new">
                      <svg className="help-icon help-icon-padding" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 18.027 18.027">
                        <path id="ic24-help" d="M10.513,2A8.513,8.513,0,1,1,2,10.513,8.513,8.513,0,0,1,10.513,2Zm0,1.7a6.811,6.811,0,1,0,6.811,6.811A6.811,6.811,0,0,0,10.513,3.7Zm0,10.216a.851.851,0,1,1-.851.851A.851.851,0,0,1,10.513,13.919Zm0-8.513a3.406,3.406,0,0,1,1.013,6.657l-.162.046v.107a.851.851,0,0,1-1.7.1l-.006-.1v-.851a.852.852,0,0,1,.752-.846l.226-.01a1.7,1.7,0,1,0-1.83-1.7.851.851,0,0,1-1.7,0A3.405,3.405,0,0,1,10.513,5.405Z" transform="translate(-2 -2)" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item className="demo demo-item" onClick={() => openTour()}>
                        <FontAwesomeIcon icon={faDesktop} className="fa-1x demo-icon" /> {t('navbar.demo')}
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      {!localStorage.getItem("guest") ?
                        <Dropdown.Item className="demo report-item" onClick={() => report()}>
                          <FontAwesomeIcon icon={faEnvelope} className="fa-1x demo-icon" /> {t('navbar.report')}
                        </Dropdown.Item>
                        : null}
                    </Dropdown.Menu>
                  </Dropdown>
                  :
                  <Dropdown className="help report-icon" data-tut="reactour__help">
                    <Dropdown.Toggle variant="" id="" className="help-toggle help-icon-new">
                      <svg class="help-icon help-icon-padding" xmlns="http://www.w3.org/2000/svg" width="18.027" height="18.027" viewBox="0 0 17.027 17.027">
                        <path id="ic24-help" d="M10.513,2A8.513,8.513,0,1,1,2,10.513,8.513,8.513,0,0,1,10.513,2Zm0,1.7a6.811,6.811,0,1,0,6.811,6.811A6.811,6.811,0,0,0,10.513,3.7Zm0,10.216a.851.851,0,1,1-.851.851A.851.851,0,0,1,10.513,13.919Zm0-8.513a3.406,3.406,0,0,1,1.013,6.657l-.162.046v.107a.851.851,0,0,1-1.7.1l-.006-.1v-.851a.852.852,0,0,1,.752-.846l.226-.01a1.7,1.7,0,1,0-1.83-1.7.851.851,0,0,1-1.7,0A3.405,3.405,0,0,1,10.513,5.405Z" transform="translate(-2 -2)" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {!localStorage.getItem("guest") ?
                        <Dropdown.Item className="demo report-item" onClick={() => report()}>
                          <FontAwesomeIcon icon={faEnvelope} className="fa-1x demo-icon" /> {t('navbar.report')}
                        </Dropdown.Item>
                        : null}
                    </Dropdown.Menu>
                  </Dropdown>
                }
                {windowWidth > 319 && (
                  <Dropdown className="help notify-icon" data-tut="reactour__notify" onToggle={() => handleAllChange()}>
                    <Dropdown.Toggle
                      variant=""
                      id=""
                      className="help-toggle help-icon-new"
                    >
                      {announceSessionStatus || ifNewNotif ?
                        <FontAwesomeIcon icon={faBell} className="help-icon announcements-icon-a bell-animation" onClick={() => props.setWikiSidebar(false)} /> :
                        <FontAwesomeIcon icon={faBellRegular} className={"help-icon announcements-icon "} onClick={() => props.setWikiSidebar(false)} />}
                    </Dropdown.Toggle>
                    <Dropdown.Menu renderOnMount={true}>
                      <Dropdown.Item
                      >
                        <Announcements
                          setSearchFilterword={setSearchFilterword}
                          setWikiSidebar={props.setWikiSidebar}
                          handleChange={handleChange}
                          handleAnnouncements={handleAnnouncements}
                        />
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        style={{ paddingLeft: '0' }} >
                        <Notify checkNewNotif={checkNewNotif} />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
                {/* Language Selector */}
                {windowWidth > 600 && <LanguageSelector />}
                <Dropdown className={(localStorage.getItem('guest') || localStorage.getItem('species')) && windowWidth > 450 ? 'logout-icon-guest' : windowWidth < 450 ? 'logout-icon-small' : "logout-icon"}>
                  <Dropdown.Toggle variant="" id="" data-tut="reactour__user" className="help-content">
                    <svg className="help-icon space-between-icon-text" xmlns="http://www.w3.org/2000/svg" width="17.027" height="17.027" viewBox="0 0 17.027 17.027">
                      <path id="ic24-user" d="M6.257,13.919H14.77a4.257,4.257,0,0,1,4.257,4.257.851.851,0,0,1-1.7.1l-.01-.249a2.554,2.554,0,0,0-2.4-2.4l-.15,0H6.257A2.554,2.554,0,0,0,3.7,18.175a.851.851,0,0,1-1.7,0,4.257,4.257,0,0,1,4.072-4.253l.185,0h0ZM10.513,2A5.108,5.108,0,1,1,5.405,7.108,5.108,5.108,0,0,1,10.513,2Zm0,1.7a3.405,3.405,0,1,0,3.405,3.405A3.405,3.405,0,0,0,10.513,3.7Z" transform="translate(-2 -2)" />
                    </svg>
                    {(windowWidth > 320 ? t('common.hi') + " " : '') + (windowWidth > 402 ? (user && user.name ? (user && user.name).charAt(0).toUpperCase() + (user && user.name).slice(1).split(" ")[0] : "Guest") : '') + " "}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item className="demo" onClick={() => {
                      loggingOut();
                    }}>
                      <FontAwesomeIcon
                        icon={faSignOutAlt}
                        className="fa-1x"
                      ></FontAwesomeIcon>
                      {t('common.logout')}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Report isReportModalOpen={isReportModalOpen} report={report} />
            {localStorage.getItem("species") ?
              <AddSpeciesSample addSampleOpen={addSampleOpen} toggleAddSampleModal={toggleAddSampleModal} /> :
              <AddSample addSampleOpen={addSampleOpen} toggleAddSampleModal={toggleAddSampleModal} />
            }
          </header>
        </>
      }
      <RenderRoute
        isTourOpen={isTourOpen}
        closeTour={closeTour}
        openTour={openTour}
        sampleSearch={sampleSearch}
        setSearch={setSearch}
        sideBarHover={sideBarHover}
      />
      {props.isTourOpen ? (
        <Tour
          isOpen={props.isTourOpen}
          closeTour={props.closeTour}
          openTour={props.openTour}
          sideBarHover={sideBarHover}
        />
      ) : null}
    </>
  );
};
